module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/tabs/spk-tab-pane/spk-tab-pane.component.scss
// module id = ./src/app/components/framework/spk/layouts/tabs/spk-tab-pane/spk-tab-pane.component.scss
// module chunks = main